export default "__VITE_ASSET__HRSizbiZ__"